module.exports = __webpack_public_path__ + "f31321a17143c3043486b0ff328ccebb.MP3";